module.exports = __webpack_public_path__ + "static/media/logo-googleplay.fc84630a.png";